export const COMMON_MESSAGES = {
  DEFAULT_WEEK_TITLE: "This week",
  LAST_WEEK_TITLE: "Last week"
};